import { defineComponent as n, createBlock as r, openBlock as a, unref as l, mergeProps as p, withCtx as v, createElementVNode as m } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconTv",
  __name: "IconTv",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (a(), r(l(c), p(t, { "view-box": "0 0 24 24" }), {
      default: v(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M3.5 4.25A1.25 1.25 0 0 0 2.25 5.5v10a1.25 1.25 0 0 0 1.25 1.25h7.75v1.5H8.5a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-2.75v-1.5h7.75a1.25 1.25 0 0 0 1.25-1.25v-10a1.25 1.25 0 0 0-1.25-1.25h-17m16.75 11v-9.5H3.75v9.5h16.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
